import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Wishlist.css";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../cart/Cart";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ============================
        WISHLIST API
============================ */

// ✅ GET WISHLIST
export const getWishlist = async (customer_id) => {
  const formData = new FormData();
  formData.append("customer_id", customer_id);

  const res = await axios.post(
    `${BASE_URL}customer_wish_list_details`,
    formData,
  );

  return res.data;
};

// ✅ ADD TO WISHLIST ( THIS WAS MISSING – ERROR FIX)
export const addToWishlist = async (customer_id, product_id) => {
  const formData = new FormData();
  formData.append("customer_id", customer_id);
  formData.append("product_id", product_id);

  const res = await axios.post(
    `${BASE_URL}customer_wish_list_insert`,
    formData,
  );

  return res.data;
};

// ✅ REMOVE FROM WISHLIST
export const removeFromWishlist = async (customer_id, product_id) => {
  const formData = new FormData();
  formData.append("customer_id", customer_id);
  formData.append("product_id", product_id);

  const res = await axios.post(
    `${BASE_URL}customer_wish_list_remove`,
    formData,
  );

  return res.data;
};

/* ============================
      WISHLIST COMPONENT
============================ */

const Wishlist = () => {
  // ADD TO CART FROM WISHLIST
  const handleAddToCart = async (product_id) => {
    try {
      const res = await addToCart(customer_id, product_id, 1);

      if (res.api_success) {
        // remove from wishlist
        await removeFromWishlist(customer_id, product_id);

        // update UI
        setWishItems((prev) =>
          prev.filter((item) => item.product_id !== product_id),
        );

        toast.success("Moved to cart");

        // navigate("/cart");
      } else {
        toast.error(res.message || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Wishlist add to cart error:", error);
      toast.error("Something went wrong");
    }
  };

  const customer_id = localStorage.getItem("customer_id");
  const navigate = useNavigate();

  const [wishItems, setWishItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // FETCH WISHLIST
  const fetchWishlist = async () => {
    try {
      setLoading(true);
      const data = await getWishlist(customer_id);

      if (data.api_success) {
        setWishItems(data.wishlist_items || []);
      } else {
        setWishItems([]);
      }
    } catch (error) {
      console.error("Wishlist fetch error:", error);
      setWishItems([]);
    } finally {
      setLoading(false);
    }
  };

  // REMOVE ITEM
  const handleRemove = async (product_id) => {
    try {
      await removeFromWishlist(customer_id, product_id);
      setWishItems((prev) =>
        prev.filter((item) => item.product_id !== product_id),
      );
    } catch (error) {
      console.error("Remove wishlist error:", error);
    }
  };

  // NAVIGATE TO PRODUCT DETAILS
  const handleProductClick = (product_id) => {
    navigate(`/product-details/${product_id}`);
  };

  useEffect(() => {
    if (customer_id) fetchWishlist();
  }, [customer_id]);

  return (
    <div className="wishlist-container">
      <h2 className="wishlist-heading">My Wishlist</h2>

      <div className="wishlist-items">
        {!loading && wishItems.length === 0 && (
          <p className="empty-text">Your wishlist is empty</p>
        )}

        {wishItems.map((item) => (
          <div className="wishlist-item" key={item.product_id}>
            {/* CLICKABLE PRODUCT AREA */}
            <div
              className="wishlist-click-area"
              onClick={() => handleProductClick(item.product_id)}
            >
              <img
                className="item-img"
                src={item.product_image}
                alt={item.product_name}
              />

              <div className="item-details">
                <p className="item-name">{item.product_name}</p>
                <p className="item-price">
                  ₹{parseFloat(item.selling_price || 0).toFixed(0)}
                </p>
              </div>
            </div>

            {/* ACTION BUTTONS */}
            <div className="btn-group">
              <button
                className="add-to-cart-btn"
                onClick={() => handleAddToCart(item.product_id)}
              >
                Add to Cart
              </button>

              <button
                className="remove-btn"
                onClick={() => handleRemove(item.product_id)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
